"use client";

import ReactQueryProvider from "@/setup/react-query";
import { ToastProvider } from "@/context/ToastProvider";
import { LocaleProvider } from "@/setup/locale-provider/index";
import { ProjectInfoProvider } from "@/context/ProjectInfoContext";
import PremiumIntro from "@/components/Layouts/PremiumIntro";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ReactQueryProvider>
      <LocaleProvider>
        <ProjectInfoProvider>
          <ToastProvider>
            <PremiumIntro />
            {children}
          </ToastProvider>
        </ProjectInfoProvider>
      </LocaleProvider>
    </ReactQueryProvider>
  );
}
